<template>
  <div v-show="show" class="tips-container">
      <div class="bg"></div>
      <div class="tips-content">
          <p class="title">温馨提示</p>
          <div class="Knews">撤回后稿件内容需要重新提交审核，是否继续？</div>
          <div class="btns">
              <p @click="show = false;r(true);" class="green">确定</p>
              <p @click="show = false;">取消</p>
          </div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'confirm',
  data() {
    return {
      show: true,
      config: {
        msg: '',
        alpha: {
          title: '',
          handle: () => {}
        },
        beta: {
          title: '',
          handle: () => {}
        }
      },
      r: null
    }
  },
  methods: {
    open(c, r) {
      this.config = c
      this.r = r
      this.show = true
    },
    close() {
      this.show = false
    },
    // confirm() {
    //   this.r(true)
    //   this.close()
    // },
    alpha() {
      this.config.alpha.handle()
      this.r(true)
      this.close()
    },
    beta() {
      this.config.beta.handle()
      this.r(true)
      this.close()
    },
    cancel() {
      this.r(false)
      this.close()
    }
  }
}
</script>

<style lang="less" scoped>
  @import '../../assets/css/global.less';
  .tips-container {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    z-index: 1000;

    .bg {
        position: absolute;
        z-index: -1;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(50, 59, 75, 0.3);
        backdrop-filter: blur(1.6px);
    }

    .tips-content {
        display: flex;
        flex-direction: column;
        width: 432px;
        background: #FFFFFF;
        box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.15);
        border-radius: 4px;
        padding: 32px 32px 24px;
        box-sizing: border-box;

        .title {
            font-size: 16px;
            line-height: 24px;
            color: #323B4B;
            font-weight: bold;
            margin-bottom: 12px;
        }

        &>div {
            &:nth-of-type(1) {
                margin-bottom: 14px;
            }
        }

        .noKnews {
            font-size: 14px;
            line-height: 22px;
            color: #666666;

            span {
                color: #41B48C;
            }
        }

        .Knews {
            font-size: 14px;
            line-height: 22px;
            color: #666666;

            span {
                color: #41B48C;
            }
        }

        .btns {
            display: flex;
            flex-direction: row;
            justify-content: flex-end;
            align-items: center;
            margin-top: 24px;

            p {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 65px;
                height: 32px;
                font-size: 14px;
                background: #B9C3C3;
                color: #FFF;
                border-radius: 4px;
                user-select: none;
                cursor: pointer;

                &.green {
                    background: #41B48C;
                    margin-right: 8px;
                }
            }
        }
    }
}
</style>
